import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import MainButton from '../../../shared/layout/buttons/MainButton';
import { fetchAdminBills } from '../../../services/Http/AdminApi';
import { useCurrency } from '../../../context/CurrencyProvider';

const AdminBills = () => {
    const { formatEurAmount } = useCurrency();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await fetchAdminBills({ period: '30d', per_page: 25 });
            setRows(resp?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load bills');
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { load(); }, [load]);

    const columns = useMemo(() => ([
        { key: 'organization_name', label: 'Organization' },
        { key: 'billing_period_start', label: 'Period Start' },
        { key: 'billing_period_end', label: 'Period End' },
        { key: 'status', label: 'Status' },
        { key: 'transaction_fee_amount', label: 'Tx Fees', render: (r) => formatEurAmount(r.transaction_fee_amount) },
        { key: 'cross_sell_earnings', label: 'Cross-sell', render: (r) => formatEurAmount(r.cross_sell_earnings) },
        { key: 'total_amount', label: 'Total', render: (r) => formatEurAmount(r.total_amount) },
    ]), [formatEurAmount]);

    return (
        <PageContainer>
            <PageHeader><PageTitle>Organization Bills</PageTitle></PageHeader>
            <PageContent>
                <AdminFilterBar><div>Generated organization bills and statuses</div><MainButton size="small" onClick={load}>Refresh</MainButton></AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No bills found" />
            </PageContent>
        </PageContainer>
    );
};
export default AdminBills;
